
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("im18V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5cb2b0e8c7c14f9$var$_react = $d5cb2b0e8c7c14f9$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $d5cb2b0e8c7c14f9$var$_personAvatar = $d5cb2b0e8c7c14f9$var$_interopRequireDefault((parcelRequire("4wwVl")));
function $d5cb2b0e8c7c14f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d5cb2b0e8c7c14f9$var$UserAvatarCircleIcon = (props)=>/*#__PURE__*/ $d5cb2b0e8c7c14f9$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="9" r="3" fill="inherit"/><path fill="inherit" fill-rule="nonzero" d="M7 18.245A7.97 7.97 0 0 0 12 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2z"/></g></svg>`
    }, props, {
        newIcon: $d5cb2b0e8c7c14f9$var$_personAvatar.default
    }));
$d5cb2b0e8c7c14f9$var$UserAvatarCircleIcon.displayName = 'UserAvatarCircleIcon';
var $d5cb2b0e8c7c14f9$var$_default = module.exports.default = $d5cb2b0e8c7c14f9$var$UserAvatarCircleIcon;

});


//# sourceMappingURL=user-avatar-circle.b2a1b18a.js.map
